import _taggedTemplateLiteral from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import React from "react";
var __jsx = React.createElement;
import { Fragment } from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { graphql, compose } from 'react-apollo';
import styled from 'styled-components';
import MediaQuery from 'react-responsive';
import _ from 'lodash';
import { Container, Loader, Heart } from "../_global";
import MerchantList from "../Merchant/List";
import Toggle from "../_global/Toggle";
import { colours, fontSizes, responsiveQuery } from "../../constants/css";
import PageHeaderMobile from "../_global/PageHeaderMobile";
var heart = "/static/icons/ico_heart.svg";
import Button from "../_global/Button";
import { NoFavourites } from "./NoFavourites";
var TopLine = styled.div.withConfig({
  displayName: "Favourites__TopLine",
  componentId: "sc-1laloh5-0"
})(["white-space:nowrap;h1,div,p,span{display:inline-block;vertical-align:middle;}h1{font-size:1.5rem;}"]);
var BonusPoints = styled.p.withConfig({
  displayName: "Favourites__BonusPoints",
  componentId: "sc-1laloh5-1"
})(["padding-left:2em;padding-right:1em;"]);
var NoFavouritesCentered = styled.div.withConfig({
  displayName: "Favourites__NoFavouritesCentered",
  componentId: "sc-1laloh5-2"
})(["text-align:center;font-weight:bold;padding-bottom:1em;align-items:center;"]);

// mobile tags
var NoFavouritesMobile = styled.div.withConfig({
  displayName: "Favourites__NoFavouritesMobile",
  componentId: "sc-1laloh5-3"
})(["height:35rem;background-color:", ";"], colours.qantasMediumLightGrey);
var IconHeartContainer = styled.div.withConfig({
  displayName: "Favourites__IconHeartContainer",
  componentId: "sc-1laloh5-4"
})(["padding-top:9rem;> div{width:6.5rem;height:6.5rem;margin:0 auto;background:url('", "') no-repeat;}"], heart);
var Description = styled.div.withConfig({
  displayName: "Favourites__Description",
  componentId: "sc-1laloh5-5"
})(["margin:2rem auto 0 auto;max-width:18.75rem;> h4,p{font-size:", ";line-height:1.5rem;text-align:center;}"], fontSizes.base);
var BrowseButton = styled(Button).withConfig({
  displayName: "Favourites__BrowseButton",
  componentId: "sc-1laloh5-6"
})(["width:20rem;height:2.75rem;display:block;margin:2.75rem auto 0 auto;"]);
var toggleBonus = function toggleBonus(bonusOn) {
  document.querySelectorAll('[id^="notbonus"]').forEach(function (s) {
    // eslint-disable-next-line no-param-reassign
    s.style.display = bonusOn ? 'none' : 'flex';
  });
};
var Favourites = function Favourites(props) {
  var _props$loading = props.loading,
    loading = _props$loading === void 0 ? true : _props$loading,
    _props$error = props.error,
    error = _props$error === void 0 ? {} : _props$error,
    _props$merchants = props.merchants,
    merchants = _props$merchants === void 0 ? [] : _props$merchants,
    favourites = props.user.favourites;
  var favMerchants = merchants.filter(function (m) {
    return favourites && favourites[m.merchantId] && !m.isSpooky;
  });
  var bonusRibbons = _.get(props, ['bonusCampaignItems', '0', 'bonusRibbons'], []);
  if (loading) {
    return __jsx(Loader, {
      fullPage: true
    });
  }
  if (error && error.message) {
    return __jsx(Container, null, "Error: ", error.message);
  }
  return __jsx(React.Fragment, null, __jsx(MediaQuery, {
    query: responsiveQuery.largerThanMobileNew
  }, __jsx(Container, {
    wideView: true
  }, __jsx(TopLine, null, __jsx("h1", null, "My favourites"), favMerchants && favMerchants.length > 0 ? __jsx("span", null, __jsx(BonusPoints, null, "Bonus Points"), __jsx(Toggle, {
    onChange: toggleBonus
  })) : null), __jsx("p", null, "View your personal collection of favourite brands in one place for easier access to shop your top brands, and be notified when they\u2019re offering bonus Qantas Points. With hundreds of brands (and counting), don\u2019t forget to continue to add new brands to your Favourites Collection", __jsx(Heart, {
    isFilled: true
  })), __jsx("div", null, favMerchants && favMerchants.length > 0 ? __jsx(MerchantList, {
    merchants: favMerchants,
    skipMerchantPage: true,
    plusSign: true,
    bonusRibbons: bonusRibbons
  }) : __jsx(NoFavouritesCentered, null, "Start adding your favourite brands to your Collection", __jsx(NoFavourites, null))))), __jsx(MediaQuery, {
    query: responsiveQuery.mobileNew
  }, __jsx(Container, {
    mobilePadding: "0"
  }, favMerchants && favMerchants.length > 0 ? __jsx(React.Fragment, null, __jsx(PageHeaderMobile, null, __jsx("h1", null, "Favourites")), __jsx(MerchantList, {
    merchants: favMerchants,
    skipMerchantPage: true,
    plusSign: true,
    bonusRibbons: bonusRibbons,
    isMobile: true
  })) : __jsx(NoFavouritesMobile, null, __jsx(IconHeartContainer, null, __jsx("div", null)), __jsx(Description, null, __jsx("h4", null, "You currently do not have any favourites saved"), __jsx("p", null, "Curate your top brands and start adding them to your Favourites Collection.")), __jsx(BrowseButton, {
    primary: true,
    pageLink: "/all-stores"
  }, "BROWSE STORES")))));
};
var merchantQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query myFavouritesMerchants {\n    bonusCampaignItems(first: 1) {\n      bonusRibbons {\n        color\n        backgroundColor\n        title\n        name\n      }\n    }\n    merchants: myFavouritesMerchants {\n      merchantId\n      merchantIdMCO\n      merchantIdOLM\n      merchantIdDirect\n      merchantName\n      merchantLogoSquare\n      is_elevated\n      is_new\n      has_free_ship\n      has_coupon_code\n      isVisible\n      isSpooky\n      rebate {\n        rebate_user\n        start_date\n        end_date\n      }\n      was_rebate {\n        rebate_user\n      }\n      directOffers {\n        offerType\n        startDate\n        endDate\n        points\n        perValue\n        bespokeOffer\n        exclusions\n        ctaLink\n        ctaName\n      }\n    }\n  }\n"])));
var mapStateToProps = function mapStateToProps(_ref) {
  var user = _ref.user;
  return {
    user: user
  };
};
export default compose(connect(mapStateToProps, null), graphql(merchantQuery, {
  skip: function skip(_ref2) {
    var _ref2$user = _ref2.user,
      authenticated = _ref2$user.authenticated,
      authorized = _ref2$user.authorized;
    return !authenticated && !authorized;
  },
  props: function props(_ref3) {
    var data = _ref3.data;
    return data;
  },
  options: function options() {
    return {
      fetchPolicy: 'no-cache',
      ssr: false
    };
  }
}))(Favourites);